import { render, staticRenderFns } from "./CreateEditPrinter.vue?vue&type=template&id=b0b244ee"
import script from "./CreateEditPrinter.vue?vue&type=script&lang=js"
export * from "./CreateEditPrinter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports